import { instance as axios, setJwtToken } from "../../config/axiosInstance";

// ---------------------login----------------------------------
export const loginApi = async (data) => {
  return await axios.post("/auth/login", data);
};
// ---------------------forgot-email------send-link--------------------------
export const forgotApi = async (data) => {
  return await axios.post("/auth/sendLink", data);
};
// ---------------------reset-password---------------------------------
export const resetPasswordApi = async (data) => {
  return await axios.post(`/auth/reset_password`, data);
};
// __________________________ change Password ______________________________________
export const changePasswordApi = async (data) => {
  return await axios.put(`/setting/change_password`, data, setJwtToken());
};

// ---------------------verify-otp-----------------------------
export const verifyOtpApi = async (data) => {
  return await axios.post("/auth/verify_otp", data);
};

//----------user---from-the-mobile----------->
// ---------verify-email-----throw-the-user-link--------------------------
export const userVerifiedEmailApi = async (token) => {
  return await axios.post(`auth/verify_email_user`, token);
};
// --------reset-password-----throw-the-user-link--------------------------
export const resetPasswordUserApi = async (data) => {
  return await axios.post(`/auth/reset_password_user`, data);
};
